import { render } from "./release.vue?vue&type=template&id=447a6d6a&scoped=true&bindings={\"topImg\":\"data\",\"questionIcon1\":\"data\",\"questionIcon2\":\"data\",\"Icon1\":\"data\",\"Icon2\":\"data\",\"showMore\":\"data\"}"
import script from "./release.vue?vue&type=script&lang=js"
export * from "./release.vue?vue&type=script&lang=js"

import "./release.vue?vue&type=style&index=0&id=447a6d6a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-447a6d6a"

export default script